import { StepUpRequiredError } from '../../api/errors';

export const STEPUP_IDVER_ACR_VALUE = 'urn:mgm:loa:1fa:idver';

export interface StepUpChallenge {
  acrValue: string;
  stepupContextId: string;
}

const parseAuthParams = (header: string): Record<string, string> => {
  const params: Record<string, string> = {};
  const paramPattern = /([a-zA-Z_][a-zA-Z0-9_]*)=(?:"([^"]*)"|([^\s,]+))/g;
  let match: RegExpExecArray | null;

  while ((match = paramPattern.exec(header)) !== null) {
    params[match[1]] = match[2] ?? match[3];
  }

  return params;
};

/**
 * Parses a WWW-Authenticate header and returns the identity-verification step-up
 * challenge when present. The expired-authentication variant (carries `max_age`)
 * is a distinct challenge shape handled elsewhere and is intentionally ignored here.
 */
export const parseStepUpChallenge = (wwwAuthenticateHeader: string | null | undefined): StepUpChallenge | null => {
  if (!wwwAuthenticateHeader) return null;

  const params = parseAuthParams(wwwAuthenticateHeader);

  const acrValue = params.acr_value ?? params.acr_values;
  const stepupContextId = params.stepup_context_id;

  if (acrValue !== STEPUP_IDVER_ACR_VALUE || !stepupContextId) return null;

  return { acrValue, stepupContextId };
};

export const throwIfStepUpChallenge = (status: number, headers: Headers | null | undefined, enabled: boolean): void => {
  if (!enabled || status !== 401 || !headers) return;

  const challenge = parseStepUpChallenge(headers.get('WWW-Authenticate'));

  if (challenge) {
    throw new StepUpRequiredError(challenge.stepupContextId);
  }
};
